export const formatCurrency = (
  value,
  includeDollarSign = false,
  includeDecimals = false,
  currency = "USD",
) => {
  const digits = includeDecimals || value % 1 !== 0 ? 2 : 0
  const props = {
    minimumFractionDigits: digits,
  }
  if (includeDollarSign) {
    props.style = "currency"
    props.currency = currency
  }
  const formatter = new Intl.NumberFormat("en-US", props)

  try {
    return formatter.format(value)
  } catch (err) {
    return "0"
  }
}

export const currencyToCents = (amount) => (Number(amount) * 100).toFixed()
